export default __webpack_public_path__ + "static/media/assessment-tick.55867fcc.svg";